import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface chartsConfigData {
    tipo_grafico: string,
    instrumentos_ativos: string[],
    configuracoes: string;
    uuid?: string;
}

const create = async (id_barragem: string, data: chartsConfigData): Promise<any | Error> => {
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post(`./configuracao?uuid=${id_barragem}`, data, {
            headers: {
                Authorization: `${token}`,
            },
        });

        if (response.data) {
            return response;
        }

    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.message) {
            throw new Error(error.response.data.message);
        } else if (error.message) {
            throw new Error(error.message);
        } else {
            throw new Error('Erro ao salvar configuração do gráfico.');
        }
    }
};

const get = async (id_barragem: string, id_user: string): Promise<any> => {
	await AuthService.verify();

	try{
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`/configuracoes?uuid_barragem=${id_barragem}&uuid_usuario=${id_user}`, {
			headers: {
				Authorization: `${token}`
			}
		});

		if(response.data){
			return response.data;
		}
	} catch (error) {
		console.log(error);
		return new Error((error as {menssage: string}).menssage || 'Erro ao buscar chamados');
	}
};

const delet = async (id_config: string): Promise<any | Error> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.delete(`./configuracao?uuid=${id_config}`, {
			headers: {
				Authorization: `${token}`
			},
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Falha ao deletar registro');
	} catch (error) {
		Error((error as { message: string }).message || 'Erro ao deletar registro');
	}
};


export const chartsConf = {
    create,
    get,
    delet
};